window.open = new Proxy(window.open, {
  apply(target, thisArg, argArray) {
    // 以`/`开头的路径 视为页面路径, 其他路径视为外部链接
    if (argArray[0] && argArray[0].startsWith('/')) {
      const { href } = new URL(
        // `/health-management` 的作用见 `config/config.ts`
        `/health-management${argArray[0] ?? ''}`,
        window.origin,
      )
      return target.call(thisArg, href, ...argArray.slice(1))
    }
    return target.call(thisArg, ...argArray)
  },
})
